import type { CatalogRepository } from '#/domain/catalog/CatalogRepository'
import type { CatalogLayerCategory } from '#/domain/catalog/CatalogLayerCategory'

export class GetLayerCategoriesByOrgIdUseCase {
  constructor(private readonly repository: CatalogRepository) {}

  execute(organizationId: string): Promise<CatalogLayerCategory[]> {
    return this.repository.findLayerCategoriesByOrganizationId(organizationId)
  }
}
